/**
 * 「帮我写脚本」按钮(贴在「想拍什么」框旁)+ 写失败/待确认两个小状态。
 * 调用与回填纪律在 `useRealScriptWriter`,这里只管渲染。
 */
import { Loader2, Sparkles } from "lucide-react";

import { Button } from "@/shared/ui/button";
import type { RealScriptWriter } from "./useRealScriptWriter";

export function RealScriptButton({
  writer,
  onClick,
}: {
  writer: RealScriptWriter;
  onClick: () => void;
}) {
  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      data-testid="real-write-script"
      disabled={writer.writing}
      onClick={onClick}
      title="按你选的出镜人、时长和想法(或样片/爆款套路)写一段视频模型能直接用的提示词,写好填进框里,你可以再改。免费。"
    >
      {writer.writing ? (
        <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />
      ) : (
        <Sparkles className="mr-1.5 h-3.5 w-3.5" />
      )}
      {writer.writing ? "正在写…" : "帮我写脚本"}
    </Button>
  );
}

export function RealScriptStatus({ writer }: { writer: RealScriptWriter }) {
  if (writer.error) {
    return (
      <p data-testid="real-write-script-error" className="text-2xs text-destructive">
        {writer.error}
      </p>
    );
  }
  if (writer.pending) {
    return (
      <div
        data-testid="real-write-script-pending"
        className="space-y-2 rounded-md border border-primary/40 bg-primary/5 p-3 text-xs"
      >
        <div className="font-medium">脚本写好了 —— 你在等的时候改过框里的内容,所以没直接覆盖:</div>
        <p className="max-h-40 overflow-y-auto whitespace-pre-wrap leading-relaxed text-muted-foreground">
          {writer.pending.prompt}
        </p>
        <div className="flex gap-2">
          <Button
            type="button"
            size="sm"
            data-testid="real-write-script-accept"
            onClick={writer.acceptPending}
          >
            用这版替换框里内容
          </Button>
          <Button type="button" size="sm" variant="ghost" onClick={writer.dismissPending}>
            不用了
          </Button>
        </div>
      </div>
    );
  }
  return null;
}
